var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.1,15.4c-0.3-0.7-0.6-1.2-1.1-1.7c-0.5-0.5-1-0.8-1.7-1.1c-0.5-0.2-1.3-0.4-2.7-0.5c-1.5-0.1-2-0.1-5.9-0.1 c-3.9,0-4.3,0-5.9,0.1c-1.4,0.1-2.2,0.3-2.7,0.5c-0.7,0.3-1.2,0.6-1.7,1.1c-0.5,0.5-0.8,1-1.1,1.7c-0.2,0.5-0.4,1.3-0.5,2.7 c-0.1,1.5-0.1,2-0.1,5.9c0,3.9,0,4.3,0.1,5.9c0.1,1.4,0.3,2.2,0.5,2.7c0.3,0.7,0.6,1.2,1.1,1.7c0.5,0.5,1,0.8,1.7,1.1 c0.5,0.2,1.3,0.4,2.7,0.5c1.5,0.1,2,0.1,5.9,0.1c3.9,0,4.3,0,5.9-0.1c1.4-0.1,2.2-0.3,2.7-0.5c0.7-0.3,1.2-0.6,1.7-1.1 c0.5-0.5,0.8-1,1.1-1.7c0.2-0.5,0.4-1.3,0.5-2.7c0.1-1.5,0.1-2,0.1-5.9c0-3.9,0-4.3-0.1-5.9C35.6,16.7,35.3,15.9,35.1,15.4z  M23.8,31.5c-4.1,0-7.5-3.3-7.5-7.5c0-4.1,3.3-7.5,7.5-7.5c4.1,0,7.5,3.3,7.5,7.5C31.3,28.1,27.9,31.5,23.8,31.5z M31.6,18 c-1,0-1.7-0.8-1.7-1.7c0-1,0.8-1.7,1.7-1.7c1,0,1.7,0.8,1.7,1.7C33.3,17.2,32.5,18,31.6,18z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -10.0035 23.8552)",
    cx: 23.8,
    cy: 24,
    rx: 4.8,
    ry: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0C10.7,0,0,10.7,0,24s10.7,24,24,24s24-10.7,24-24S37.2,0,24,0z M38.2,30c-0.1,1.5-0.3,2.6-0.7,3.5 c-0.4,1-0.9,1.8-1.7,2.6c-0.8,0.8-1.6,1.3-2.6,1.7c-0.9,0.4-2,0.6-3.5,0.7c-1.6,0.1-2,0.1-6,0.1c-4,0-4.4,0-6-0.1 c-1.5-0.1-2.6-0.3-3.5-0.7c-1-0.4-1.8-0.9-2.6-1.7c-0.8-0.8-1.3-1.6-1.7-2.6c-0.4-0.9-0.6-2-0.7-3.5c-0.1-1.6-0.1-2-0.1-6 s0-4.4,0.1-6c0.1-1.5,0.3-2.6,0.7-3.5c0.4-1,0.9-1.8,1.7-2.6c0.8-0.8,1.6-1.3,2.6-1.7c0.9-0.4,2-0.6,3.5-0.7c1.6-0.1,2-0.1,6-0.1 s4.4,0,6,0.1c1.5,0.1,2.6,0.3,3.5,0.7c1,0.4,1.8,0.9,2.6,1.7c0.8,0.8,1.3,1.6,1.7,2.6c0.4,0.9,0.6,2,0.7,3.5c0.1,1.6,0.1,2,0.1,6 S38.3,28.5,38.2,30z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.5575780e1a9510eb57cf115f3d23c3a1.svg";
export { ForwardRef as ReactComponent };